import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'

import Image from '../../../shared/ui/Image'
import Link from '../../../shared/ui/Link'
import DateCard from '../../../shared/ui/DateCard'

import { withStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Avatar from '@material-ui/core/Avatar'
import ProviderIcon from '@material-ui/icons/School'

const styles = theme => ({
  root: {
  },
  imageClass: {
    width:'100%', 
    height: 0, 
    maxWidth:'25%'
  },
  cardContent: {
    padding: theme.spacing.unit * 1.5,
  },
  cardTitleContainer: {
    height: '4.5rem',
    marginBottom: theme.spacing(.5),
    overflow: 'hidden'
  },
  cardTitle: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
  cardDate: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    //fontWeight: 600,
    //color: '#666'
  },
  cardClassInfo: {
    fontWeight: 400,
    color: '#444'
  },
  cardPrice: {
    fontWeight: 400,
    color: '#444'
  },
  cardAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),    
  },
  cardProviderName: {
    fontWeight: 600,
    color: '#aaa'    
  } 
})

const TrainingClassCard = ({ theme, classes, item, linkTo, variant }) => {

  let image_url = item.course.primary_image_url
  
  let date = moment(item.training_date).format("DD MMM yyy")  

  let classInfo = item.training_days + " Day"
  if (item.training_days > 1)
    classInfo += "s"
  //classInfo = `${item.training_days}d`
  if (item.customer_type == 'public')
    classInfo += " Public Class"
  else
    classInfo += " Private Class"

  if (item.delivery_method == 'online')
    classInfo += " (Online)"
  else
    classInfo += " (Offline)"
    
  return (
    <Card className={classes.card} elevation={1}>
      <Link to={linkTo}>
        <CardMedia>
          <Image theme={theme} classes={classes}
            src={image_url}
            aspectRatio={1.33} 
          />
        </CardMedia>
        <CardContent className={classes.cardContent}>
          <Box style={{ marginTop:-50, position:'relative' }}>
            <DateCard item={item.training_date}/>
          </Box>                
          <Box className={classes.cardTitleContainer}>
            <Typography component="h6" className={classes.cardTitle}>
              { item.course.name }
            </Typography>
          </Box>
          <Typography variant="body2" className={classes.cardClassInfo}>
            { classInfo }
          </Typography>          
          {variant !== 'trainer' && variant !== 'provider' &&
          <Box display='flex' alignItems='center'>
            {item.provider ?
            <Avatar src={item.provider.logo_url} className={classes.providerCardAvatar} />
            :
            <Avatar className={classes.providerCardAvatar}>
              <ProviderIcon />
            </Avatar>
            }
            <Box flexGrow={1} ml={1}>
              <Typography variant="body2" className={classes.cardProviderName}>
                { item.provider.name }
              </Typography>
            </Box>
          </Box>
          }
        </CardContent>
      </Link>
    </Card>
  )
}

export default withStyles(styles, { withTheme: true })(
  TrainingClassCard
)
